module.exports = __webpack_public_path__ + "img/android.f26d2df0.png";